module.exports = __webpack_public_path__ + "static/img/17.6aecfbb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/17.png
// module id = GdGO
// module chunks = 0